import "core-js/stable";
import "regenerator-runtime/runtime";

import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from 'react-hot-toast';

import Home from "./components/pages/Home";
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import Header from "./components/layout/Header";
import UserFilter from "./components/pages/ByUser";
import UserContext from "./context/UserContext";
import UpdateUser from "./components/pages/UpdateUser";
import PersonalConfig from "./components/pages/PersonalConfig";
import MFASetup from "./components/pages/MFASetup";
import MFAVerify from "./components/pages/MFAVerify";
import Archive from "./components/pages/Archive";
import ErrorBoundary from "./components/layout/ErrorBoundary";

import "./App.css";
import "./styles/form.css";
import "./styles/button.css";
import "./styles/archive.css";
import Axios from "axios";
import { buildUserState } from "./utilities/tokenUtils";

function App() {
  const [userData, setUserData] = useState({
    token: undefined,
    passwordExpired: false,
    passwordExpiringSoon: false,
  });
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    const checkLoggedIn = async () => {
      try {
        let token = localStorage.getItem("auth-token");
        if (token === null) {
          setIsCheckingAuth(false);
          const setupToken = sessionStorage.getItem("setup-token");
          if (setupToken) {
            if (window.location.pathname !== '/admin/mfa-setup') {
              window.location.href = '/admin/mfa-setup';
            }
          } else if (window.location.pathname !== '/admin/login') {
            window.location.href = '/admin/login';
          }
        } else {
          const tokenRes = await Axios.post(
            `${process.env.REACT_APP_BACK_DOMAIN}/users/tokenIsValid`,
            null,
            { headers: { "x-auth-token": token } }
          );

          if (tokenRes.data.valid) {
            setUserData(buildUserState(token));
          } else {
            localStorage.removeItem("auth-token");
            token = null;
            if (window.location.pathname !== '/admin/login') {
              window.location.href = '/admin/login';
            }
          }
          setIsCheckingAuth(false);
        } 
      } catch (err) {
        console.error("Error al validar el token:", err);
        // Limpiar y redirigir si ocurre un error
        localStorage.removeItem("auth-token");
        setUserData(buildUserState(undefined));
        setIsCheckingAuth(false);
        if (window.location.pathname !== '/admin/login') {
          window.location.href = '/admin/login';
        }
      }
    };

    checkLoggedIn();
  }, []);

  // Mostrar loading mientras se verifica la autenticación
  if (isCheckingAuth) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column'
      }}>
        <p>Verificando autenticación...</p>
      </div>
    );
  }

  return (
    <>
      <ErrorBoundary>
        <BrowserRouter>
          <UserContext.Provider value={{ userData, setUserData }}>
            <Toaster />
            <Header />
            <Routes>
              <Route path="/" exact element={userData.passwordExpired ? <Navigate to="/admin/profile" replace /> : <Home />} />
              <Route path="/admin/login" exact element={<Login />} />
              <Route path="/admin/register" exact element={userData.passwordExpired ? <Navigate to="/admin/profile" replace /> : <Register />} />
              <Route path="/admin/users" exact element={userData.passwordExpired ? <Navigate to="/admin/profile" replace /> : <UserFilter />} />
              <Route path="/admin/update" exact element={userData.passwordExpired ? <Navigate to="/admin/profile" replace /> : <UpdateUser />} />
              <Route path="/admin/profile" exact element={<PersonalConfig />} />
              <Route path="/admin/mfa-setup" exact element={<MFASetup />} />
              <Route path="/admin/mfa-verify" exact element={<MFAVerify />} />
              <Route path="/archive" exact element={userData.passwordExpired ? <Navigate to="/admin/profile" replace /> : <Archive />} />
            </Routes>
          </UserContext.Provider>
        </BrowserRouter>
      </ErrorBoundary>
    </>
  );
}

export default App;
